// Shared Swiper Slider Initialization
document.addEventListener('DOMContentLoaded', function() {
  // Store swiper instances for controller functionality
  const swiperInstances = new Map();

  // Style changes that have to wait until every slider is constructed. Swiper's
  // constructor measures the DOM, so setting `display` or `opacity` between two
  // constructions invalidates layout and forces the next one to reflow — one
  // forced reflow per slider on the page. Collected here and flushed in a single
  // pass below instead.
  const pendingStyleWrites = [];

  // Initialize Swiper for all sliders with data-swiper attribute
  const swiperSliders = document.querySelectorAll('[data-swiper]');
  swiperSliders.forEach(function(swiperElement) {
    if (swiperElement && typeof Swiper !== 'undefined') {
      // Guard against a second initialisation — a duplicated script include or a
      // theme-editor section re-render would otherwise stack Swiper instances on
      // the same element.
      if (swiperElement.swiper) return;

      // Parse the data-swiper attribute
      let options = {
        slidesPerView: 2,
        spaceBetween: 20,
        loop: false,
        pagination: {
          el: swiperElement.querySelector('.swiper-pagination'),
          clickable: true,
        },
        navigation: {
          nextEl: swiperElement.parentElement.querySelector('.swiper-button-next'),
          prevEl: swiperElement.parentElement.querySelector('.swiper-button-prev'),
        },
        breakpoints: {
          768: {
            slidesPerView: 1,
            spaceBetween: 10,
          }
        }
      };

      if (swiperElement.hasAttribute('data-swiper-thumbs')) {
        const container = swiperElement.parentElement;

        options.navigation = false;

        const paginationEl = container.querySelector('.swiper-pagination--thumbs');
        if (paginationEl) {
          options.pagination = {
            el: paginationEl,
            clickable: true,
          };
        } else {
          options.pagination = false;
        }
      }

      try {
        const customOptions = JSON.parse(swiperElement.getAttribute('data-swiper'));

        // Deep merge pagination and navigation objects to preserve el properties
        if (customOptions.pagination && typeof customOptions.pagination === 'object') {
          options.pagination = { ...options.pagination, ...customOptions.pagination };
        }
        if (customOptions.navigation && typeof customOptions.navigation === 'object') {
          options.navigation = { ...options.navigation, ...customOptions.navigation };
        }

        // Merge the rest of the options
        const { pagination, navigation, ...restCustomOptions } = customOptions;
        options = { ...options, ...restCustomOptions };
      } catch (e) {
        console.warn('Invalid data-swiper JSON:', e);
      }

      // Add modules for product media gallery with controller functionality
      if (swiperElement.hasAttribute('data-swiper-main') || swiperElement.hasAttribute('data-swiper-thumbs')) {
        // Note: These modules are automatically included in the bundle version
        // The controller functionality will be available via the controller property
      }

      // Initialize Swiper
      const swiper = new Swiper(swiperElement, options);

      // Store instance for controller setup
      if (swiperElement.hasAttribute('data-swiper-main')) {
        swiperInstances.set('main', swiper);
      } else if (swiperElement.hasAttribute('data-swiper-thumbs')) {
        swiperInstances.set('thumbs', swiper);
      }

      // Auto-hide navigation and pagination when not needed
      function updateNavigationVisibility() {
        // Skip auto-hide if force navigation is enabled
        if (swiperElement.hasAttribute('data-swiper-force-navigation')) {
          return;
        }

        const slides = swiperElement.querySelectorAll('.swiper-slide');
        const slideCount = slides.length;

        // Get current active slidesPerView (accounts for breakpoints)
        let currentSlidesPerView;
        if (swiper.currentBreakpoint && swiper.params.breakpoints[swiper.currentBreakpoint]) {
          currentSlidesPerView = swiper.params.breakpoints[swiper.currentBreakpoint].slidesPerView || swiper.params.slidesPerView;
        } else {
          currentSlidesPerView = swiper.params.slidesPerView;
        }

        // Calculate if navigation is needed
        // For navigation buttons: only show if we have more slides than we can fully see
        const needsNavigation = slideCount > Math.ceil(currentSlidesPerView);

        // For pagination: show if we have more than 1 slide, regardless of slidesPerView
        // This ensures pagination shows on mobile even with fractional slidesPerView
        const needsPagination = slideCount > 1;

        // Get navigation elements from parent container
        const container = swiperElement.parentElement;
        const nextButton = container.querySelector('.swiper-button-next');
        const prevButton = container.querySelector('.swiper-button-prev');
        const pagination = container.querySelector('.swiper-pagination');

        // Hide/show navigation buttons
        if (nextButton) nextButton.style.display = needsNavigation ? '' : 'none';
        if (prevButton) prevButton.style.display = needsNavigation ? '' : 'none';

        // Hide/show pagination (different logic for pagination)
        if (pagination) pagination.style.display = needsPagination ? '' : 'none';

        if (!needsNavigation) {
          swiper.setTranslate(0);
        }
      }

      // Initial check. Deferred with the reveal so it does not force the next
      // slider's constructor to reflow; see pendingStyleWrites above.
      pendingStyleWrites.push(function () {
        swiperElement.style.opacity = '1';
        updateNavigationVisibility();
      });

      swiper.on('resize', updateNavigationVisibility);

      // Make sure pagination is updated when slide changes on swipe
      swiper.on('slideChange', function () {
        if (swiper.pagination && swiper.pagination.el) {
          swiper.pagination.update();
        }
      });
    }
  });

  // Every slider is constructed by this point, so the batched writes can land
  // together. Kept synchronous rather than deferred to a frame: collection-list
  // hides its slider until this sets opacity, and waiting would show a gap.
  pendingStyleWrites.forEach(function (write) {
    write();
  });

  // Setup controller connection between main and thumbnail sliders
  // Use setTimeout to ensure both sliders are initialized
  setTimeout(function () {
    const mainSwiper = swiperInstances.get('main');
    const thumbsSwiper = swiperInstances.get('thumbs');

    if (!mainSwiper || !thumbsSwiper) return;

    mainSwiper.thumbs.swiper = thumbsSwiper;
    mainSwiper.thumbs.init();
    mainSwiper.thumbs.update();

    const pagEl = thumbsSwiper.pagination && thumbsSwiper.pagination.el;
    if (pagEl) {
      pagEl.addEventListener('click', (e) => {
        const bullet = e.target.closest('.swiper-pagination-bullet');
        if (!bullet) return;
        const bullets = Array.from(pagEl.querySelectorAll('.swiper-pagination-bullet'));
        const index = bullets.indexOf(bullet);
        if (index >= 0) {
          thumbsSwiper.slideTo(index);
          if (mainSwiper.params.loop) mainSwiper.slideToLoop(index);
          else mainSwiper.slideTo(index);
        }
      });
    }

    thumbsSwiper.slides.forEach(function (slide, index) {
      slide.addEventListener('click', function () {
        if (mainSwiper.params.loop) mainSwiper.slideToLoop(index);
        else mainSwiper.slideTo(index);
      });
    });

    const getIndex = (s) => (s.params.loop ? s.realIndex : s.activeIndex);

    function updateThumbnailsActiveState() {
      const mainIndex = getIndex(mainSwiper);

      thumbsSwiper.slides.forEach((slide, idx) => {
        slide.classList.toggle('swiper-slide-thumb-active', idx === mainIndex);
      });

      if (thumbsSwiper.params.loop) {
        thumbsSwiper.slideToLoop(mainIndex);
      } else {
        const perView =
          typeof thumbsSwiper.params.slidesPerView === 'number'
            ? Math.max(1, Math.floor(thumbsSwiper.params.slidesPerView))
            : 1;
        const first = thumbsSwiper.activeIndex;
        const last = first + perView - 1;
        if (mainIndex < first || mainIndex > last) {
          thumbsSwiper.slideTo(mainIndex);
        } else {
          thumbsSwiper.updateSlidesClasses();
        }
      }
    }

    mainSwiper.on('slideChange transitionEnd', () => {
      updateThumbnailsActiveState()
      if (thumbsSwiper.pagination && thumbsSwiper.pagination.el) {
        thumbsSwiper.pagination.update();
      }
    });

    thumbsSwiper.on('slideChange', updateThumbnailsActiveState);
    thumbsSwiper.on('resize', updateThumbnailsActiveState);

    updateThumbnailsActiveState();
  }, 100);
});
